import React, { useEffect, useState } from "react";
import styles from "./style.module.css";
import SearchIcon from "../../../assets/icons/search.svg";
import FilterIcon from "../../../assets/icons/icon-filter.svg";
import Sidebar from "../../partials/Sidebar";
import Header from "../../partials/Header";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import { motion } from "framer-motion";
import HashLoader from "react-spinners/ClipLoader";
import { Modal, notification, Tooltip } from "antd";
import AXIOS from "../../../config/axios";
import fetchSizeList from "../../../api/lockers/fetchSizeList";
import deleteLocker from "../../../api/lockers/deleteLocker";
import InfoIcon from "../../../assets/inform.svg";
import DeleteIcon from "../../../assets/delete.svg";
import EditIcon from "../../../assets/edit.svg";
import LockerIcon from "../../../assets/opnlocker.svg";
import SuffolkLockerSelect from "../Pickup/SuffolkLockerSelect";
import QRCode from "qrcode";
import { displayLockerNumber } from "../../../utils/displayLockerNumber";
import {
  AVERY_PER_SHEET,
  printAveryLabels,
} from "./printAveryLabels";

const Lockers = () => {
  const url = process.env.REACT_APP_APP_BACK_URL;
  const [data, setData] = useState([]);
  const isAuthenticated = useSelector((state) => state.user);
  const isSuperAdmin =
    String(isAuthenticated?.role || "").toLowerCase() === "superadmin";
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const itemsPerPage = 10;
  const [isNotFound, setIsNotFound] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [itemLoadingStates, setItemLoadingStates] = useState({});
  const [doorLoadingStates, setDoorLoadingStates] = useState({});
  const [isDisplay, setIsDisplay] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [viewMode, setViewMode] = useState("list");
  const [isSuffolk, setIsSuffolk] = useState(false);
  const [imageLockers, setImageLockers] = useState([]);
  const [imageLoading, setImageLoading] = useState(false);
  const [doorInputs, setDoorInputs] = useState({});
  const [sizes, setSizes] = useState([]);
  const [qrImages, setQrImages] = useState({});
  const [selectedIds, setSelectedIds] = useState([]);
  const [printOpen, setPrintOpen] = useState(false);
  const [zoomLocker, setZoomLocker] = useState(null);
  const [printLockers, setPrintLockers] = useState([]);
  const [startPosition, setStartPosition] = useState(1);
  const [printing, setPrinting] = useState(false);
  const [credentials, setCredentials] = useState({
    size: "all",
    number: "",
    row: "",
    column: "",
  });
  const handleInput = (e) => {
    setCurrentPage(1);
    setCredentials((prevCredentials) => {
      const updatedCredentials = {
        ...prevCredentials,
        [e.target.name]: e.target.value,
      };
      fetchData(updatedCredentials);
      return updatedCredentials;
    });
  };

  useEffect(() => {
    fetchData(credentials);
    (async () => {
      const sizeData = await fetchSizeList();
      if (sizeData) {
        setSizes(sizeData.data);
      }
    })();
  }, [currentPage]);

  useEffect(() => {
    const role = String(isAuthenticated?.role || "").toLowerCase();
    if (role === "superadmin" || !isAuthenticated?.site_id) {
      setIsSuffolk(false);
      return undefined;
    }
    let stopped = false;
    fetch(`${url}/api/sites/getSite/${isAuthenticated.site_id}`)
      .then((res) => res.json())
      .then((json) => {
        if (stopped) return;
        setIsSuffolk(
          String(json?.site?.slug || "").toLowerCase() === "suffolkcounty"
        );
      })
      .catch(() => {
        if (!stopped) setIsSuffolk(false);
      });
    return () => {
      stopped = true;
    };
  }, [isAuthenticated?.role, isAuthenticated?.site_id, url]);

  useEffect(() => {
    if (viewMode !== "image" || !isSuffolk) return undefined;
    let stopped = false;
    setImageLoading(true);
    AXIOS.get("/lockers/list?page=1&limit=100")
      .then((res) => {
        if (!stopped) setImageLockers(res.data.lockers || []);
      })
      .catch(() => {
        if (!stopped) setImageLockers([]);
      })
      .finally(() => {
        if (!stopped) setImageLoading(false);
      });
    return () => {
      stopped = true;
    };
  }, [viewMode, isSuffolk]);

  useEffect(() => {
    if (viewMode !== "image" || !isSuffolk) return undefined;
    let stopped = false;
    const loadDoorStatus = () => {
      AXIOS.get("/lockers/door/status")
        .then((res) => {
          if (!stopped && res.data?.inputs) setDoorInputs(res.data.inputs);
        })
        .catch(() => {});
    };
    loadDoorStatus();
    const timer = setInterval(loadDoorStatus, 4000);
    return () => {
      stopped = true;
      clearInterval(timer);
    };
  }, [viewMode, isSuffolk]);

  const fetchData = async (fetchCredentials) => {
    try {
      setIsLoading(true);
      setIsDisplay(false);
      setIsNotFound(false);
      AXIOS.get(
        `/lockers/list?page=${currentPage}&limit=${itemsPerPage}&number=${fetchCredentials.number}&size=${fetchCredentials.size}&row=${fetchCredentials.row}&column=${fetchCredentials.column}`
      )
        .then((res) => {
          setIsLoading(false);
          console.log(res);
          if (res.data.lockers.length > 0) {
            setIsDisplay(true);
            setData(res.data.lockers);
            setSelectedIds([]);
          } else {
            setIsLoading(false);
            setIsNotFound(true);
          }
          setTotalPages(res.data.totalPages);
        })
        .catch((err) => {
          setIsLoading(false);
          console.error(err);
          throw new Error("Network response was not ok");
        });
    } catch (error) {
      console.error(error);
    }
  };
  const handleResetBtn = () => {
    const updatedCredentials = {
      number: "",
      row: "",
      column: "",
      size: "all",
    };
    // Update state and then call fetchData
    setCredentials(updatedCredentials);
    setCurrentPage(1);
    // Call fetchData with the updated credentials
    fetchData(updatedCredentials);
  };
  const handleDelete = async (id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        reverseButtons: true,
      });
      if (result.isConfirmed) {
        const res = await deleteLocker(id);
        if (res.success) {
          fetchData(credentials);
          Swal.fire("Deleted!", "Locker deleted successfully!", "success");
        } else {
          Swal.fire("Error", res.error, "error");
        }
      }
    } catch (error) {
      console.log("Error deleting record:", error);
      Swal.fire(
        "Error",
        "An error occurred while deleting the record.",
        "error"
      );
    }
  };
  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1); // react-paginate uses zero-based indexing
  };
  const HandleOpenLocker = async (id, relay) => {
    let state = "2";
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    setItemLoadingStates((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true, // Set loading to true for the clicked item
    }));
    const response = await fetch(`${url}/api/lockers/relay/state/update`, {
      mode: "cors",
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        id: id,
        state: state,
      }),
    });
    setItemLoadingStates((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: false, // Set loading to true for the clicked item
    }));
    const json = await response.json();
    console.log(json);
    if (json.success) {
      notification.success({
        message: "Success",
        description: json.message,
        duration: 3,
      });
    } else {
      setItemLoadingStates((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false, // Set loading to true for the clicked item
      }));
      notification.error({
        message: "Failed",
        description: json.error,
        duration: 3,
      });
    }
  };
  const HandleOpenDoor = async (id) => {
    let state = "2";
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    setDoorLoadingStates((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: true, // Set loading to true for the clicked item
    }));
    const response = await fetch(`${url}/api/lockers/open`, {
      mode: "cors",
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        id: id,
        state: state,
      }),
    });
    setDoorLoadingStates((prevLoadingStates) => ({
      ...prevLoadingStates,
      [id]: false, // Set loading to true for the clicked item
    }));
    const json = await response.json();
    console.log(json);
    if (json.success) {
      notification.success({
        message: "Success",
        description: json.message,
        duration: 3,
      });
    } else {
      setDoorLoadingStates((prevLoadingStates) => ({
        ...prevLoadingStates,
        [id]: false, // Set loading to true for the clicked item
      }));
      notification.error({
        message: "Failed",
        description: json.error,
        duration: 3,
      });
    }
  };
  useEffect(() => {
    let cancelled = false;
    const loadQrImages = async () => {
      const next = {};
      await Promise.all(
        data.map(async (item) => {
          const pin = String(item.pin_code || "").trim();
          if (!pin) return;
          next[item._id] = await QRCode.toDataURL(pin, {
            margin: 1,
            width: 360,
            errorCorrectionLevel: "M",
          });
        })
      );
      if (!cancelled) setQrImages(next);
    };
    loadQrImages().catch(() => {
      if (!cancelled) setQrImages({});
    });
    return () => {
      cancelled = true;
    };
  }, [data]);

  const lockerLabel = (item) => displayLockerNumber(item?.number);
  const hasPin = (item) => Boolean(String(item?.pin_code || "").trim());
  const printableOnPage = data.filter(hasPin);
  const allPageSelected =
    printableOnPage.length > 0 &&
    printableOnPage.every((item) => selectedIds.includes(item._id));
  const toggleSelected = (id) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };
  const toggleAllOnPage = () => {
    setSelectedIds(
      allPageSelected ? [] : printableOnPage.map((item) => item._id)
    );
  };
  const openPrint = (lockers) => {
    const withPin = lockers.filter(hasPin);
    if (!withPin.length) {
      notification.warning({
        message: "No QR code",
        description: "A PIN has to be created before a label can be printed.",
        duration: 4,
      });
      return;
    }
    setPrintLockers(withPin);
    setStartPosition(1);
    setPrintOpen(true);
  };
  const handlePrintSelected = () => {
    openPrint(data.filter((item) => selectedIds.includes(item._id)));
  };
  const handlePrintAll = async () => {
    try {
      const res = await AXIOS.get(
        `/lockers/list?page=1&limit=1000&number=${credentials.number}&size=${credentials.size}&row=${credentials.row}&column=${credentials.column}`
      );
      openPrint(res.data.lockers || []);
    } catch (error) {
      notification.error({
        message: "Failed",
        description: "Could not load locker QR codes.",
        duration: 3,
      });
    }
  };
  const handlePrint = async () => {
    setPrinting(true);
    const result = await printAveryLabels(printLockers, startPosition);
    setPrinting(false);
    if (!result.ok) {
      notification.error({
        message: "Failed",
        description: result.error,
        duration: 4,
      });
      return;
    }
    setPrintOpen(false);
  };
  const filledThrough = Math.min(
    AVERY_PER_SHEET,
    startPosition - 1 + printLockers.length
  );
  function toggleFilterSection() {
    setIsFilterVisible(!isFilterVisible);
  }
  const [isActive, setIsActive] = useState(false);
  const toggleActive = () => {
    setIsActive(!isActive);
  };
  // Define the CSS classes based on the isActive state
  const divClassName = isActive ? "sidebar active" : "sidebar";
  const showDepartment = data.some(
    (item) =>
      item?.departments_enabled === "yes" &&
      String(item?.department_name || "").trim()
  );
  const columnCount = showDepartment ? 9 : 8;
  return (
    <div className="general-dashboard">
      <div className="container-fluid">
        <div className="dashboard-top-row">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <div className="user-wrap">
                <h3>Lockers</h3>
                <p>List of all the Lockers registered in the system</p>
              </div>
            </div>
            <div className="col-lg-6 text-end">
              <div className="filter-right-sec">
                {isSuffolk && (
                  <div className={styles.viewToggle}>
                    <button
                      type="button"
                      className={`${styles.viewBtn} ${
                        viewMode === "list" ? styles.viewBtnActive : ""
                      }`}
                      onClick={() => setViewMode("list")}
                      aria-label="List view"
                      title="List view"
                    >
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                        <path d="M2 4.5h14M2 9h14M2 13.5h14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
                      </svg>
                    </button>
                    <button
                      type="button"
                      className={`${styles.viewBtn} ${
                        viewMode === "image" ? styles.viewBtnActive : ""
                      }`}
                      onClick={() => setViewMode("image")}
                      aria-label="Image view"
                      title="Image view"
                    >
                      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
                        <rect x="2" y="2" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.6" />
                        <rect x="10" y="2" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.6" />
                        <rect x="2" y="10" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.6" />
                        <rect x="10" y="10" width="6" height="6" rx="1" stroke="currentColor" strokeWidth="1.6" />
                      </svg>
                    </button>
                  </div>
                )}
                <button
                  type="button"
                  className={`btn btn-prim w-auto ${styles.printSelectedBtn}`}
                  onClick={handlePrintSelected}
                  disabled={!selectedIds.length}
                >
                  Print selected
                </button>
                <button
                  type="button"
                  className="btn btn-prim w-auto"
                  onClick={handlePrintAll}
                >
                  Print all
                </button>
                <div className="filter-wrap">
                  <div className="filter-box" onClick={toggleFilterSection}>
                    <img src={FilterIcon} alt="" />
                  </div>
                </div>
                {isSuperAdmin && (
                  <Link to="/locker/add" className="btn btn-prim w-auto">
                    Add New locker
                  </Link>
                )}
              </div>
            </div>
          </div>
          {isFilterVisible && (
            <>
              <motion.div
                className={`row mt-5 filter-section`}
                initial={{ opacity: 0 }} // Initial state (hidden)
                animate={{ opacity: isFilterVisible ? 1 : 0 }} // Animate opacity based on isFilterVisible
                transition={{ duration: 1.2, delay: 0.1 }}
              >
                <div className="col-12">
                  <div className="filter-right-sec filter-wrap-chat">
                    <div className="search-wrap">
                      <input
                        type="search"
                        placeholder="locker no."
                        name="number"
                        value={credentials.number}
                        onChange={handleInput}
                      />
                      <div className="search-box">
                        <img src={SearchIcon} alt="" />
                      </div>
                    </div>
                    <div className="search-wrap">
                      <input
                        type="search"
                        placeholder="row"
                        name="row"
                        value={credentials.row}
                        onChange={handleInput}
                      />
                      <div className="search-box">
                        <img src={SearchIcon} alt="" />
                      </div>
                    </div>
                    <div className="search-wrap">
                      <input
                        type="search"
                        placeholder="column"
                        name="column"
                        value={credentials.column}
                        onChange={handleInput}
                      />
                      <div className="search-box">
                        <img src={SearchIcon} alt="" />
                      </div>
                    </div>
                    <div className="filter-select d-flex align-items-center">
                      <label htmlFor="">Size</label>
                      <select
                        name="size"
                        id=""
                        value={credentials.size}
                        onChange={handleInput}
                      >
                        <option value="all">Choose size</option>
                        {sizes.map((per) => (
                          <option
                            key={per._id}
                            value={per._id}
                            style={{ textTransform: "capitalize" }}
                          >
                            {per.size}
                          </option>
                        ))}
                      </select>
                    </div>
                    <Link
                      to=""
                      onClick={handleResetBtn}
                      className="btn btn-prim w-auto"
                    >
                      RESET
                    </Link>
                  </div>
                </div>
              </motion.div>
            </>
          )}
        </div>
        {/* row */}
        {viewMode === "image" && isSuffolk ? (
          <div className="d-flex justify-content-center">
            {imageLoading ? (
              <div className="text-center py-5">
                <HashLoader color="#0b0d41" loading size={40} />
              </div>
            ) : (
              <SuffolkLockerSelect
                sizes={sizes}
                siteLockers={imageLockers}
                doorInputs={doorInputs}
                sensorColors
                viewOnly
              />
            )}
          </div>
        ) : (
        <div className="table-wrap">
          <div className="row">
            <div className="col-12">
              <div className={styles.card_box}>
                <div className={styles.tables_wrap}>
                  <div className="table-responsive">
                    <table className="table align-middle">
                      <thead>
                        <tr>
                          <th>
                            <input
                              type="checkbox"
                              aria-label="Select all QR codes on this page"
                              checked={allPageSelected}
                              onChange={toggleAllOnPage}
                              disabled={!printableOnPage.length}
                            />
                          </th>
                          <th>Locker No.</th>
                          <th>Site</th>
                          {showDepartment && <th>Department</th>}
                          <th>Relay#</th>
                          <th>Row</th>
                          <th>Column</th>
                          <th>Status</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        {isLoading && (
                          <>
                            <tr>
                              <td
                                colSpan={columnCount}
                                className="text-center"
                                style={{ background: "transparent" }}
                              >
                                <HashLoader
                                  color={`#0b0d41`}
                                  loading={isLoading}
                                  size={40}
                                  aria-label="Loading Spinner"
                                  data-testid="loader"
                                />
                              </td>
                            </tr>
                          </>
                        )}
                        {isDisplay &&
                          data.map((item, i) => (
                            <motion.tr
                              key={item._id}
                              initial={{ opacity: 0 }}
                              animate={{ opacity: 1 }}
                              transition={{ duration: 1.2, delay: i * 0.1 }}
                            >
                              <td>
                                <input
                                  type="checkbox"
                                  aria-label={`Select QR for locker ${lockerLabel(item)}`}
                                  checked={selectedIds.includes(item._id)}
                                  onChange={() => toggleSelected(item._id)}
                                  disabled={!hasPin(item)}
                                />
                              </td>
                              <td>
                                <div className={styles.lockerNoCell}>
                                  <span>
                                    Locker{" "}
                                    {String(item?.relay ?? "").trim() ||
                                      lockerLabel(item)}
                                  </span>
                                  {hasPin(item) && qrImages[item._id] ? (
                                    <button
                                      type="button"
                                      className={styles.qrThumb}
                                      aria-label={`Show QR code for locker ${lockerLabel(item)}`}
                                      onClick={() => setZoomLocker(item)}
                                    >
                                      <img
                                        src={qrImages[item._id]}
                                        alt=""
                                      />
                                    </button>
                                  ) : null}
                                </div>
                              </td>
                              <td>{item.site}</td>
                              {showDepartment && (
                                <td>
                                  {item?.departments_enabled === "yes" &&
                                  String(item?.department_name || "").trim()
                                    ? item.department_name
                                    : "—"}
                                </td>
                              )}
                              <td>{item.relay}</td>
                              <td>{item.row}</td>
                              <td>{item.column}</td>
                              <td>
                                <div className="conditions-appnt">
                                  {item.status === "available" && (
                                    <span
                                      className={`appnt-alert success`}
                                      style={{
                                        marginLeft: "0px",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {item.status}
                                    </span>
                                  )}
                                  {item.status === "occupied" && (
                                    <span
                                      className={`appnt-alert warning`}
                                      style={{
                                        marginLeft: "0px",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {item.status}
                                    </span>
                                  )}
                                  {item.status === "inactive" && (
                                    <span
                                      className={`appnt-alert danger`}
                                      style={{
                                        marginLeft: "0px",
                                        fontSize: "10px",
                                      }}
                                    >
                                      {item.status}
                                    </span>
                                  )}
                                </div>
                              </td>
                              <td className="d-flex gap-2  text-end">
                                {/* {item?.has_door === "yes" && (
                                  <button
                                    type="button"
                                    className="btn btn-warning text-white btn-sm"
                                    onClick={() => {
                                      HandleOpenLocker(item._id, item.relay);
                                    }}
                                    disabled={doorLoadingStates[item._id]}
                                  >
                                    {doorLoadingStates[item._id]
                                      ? "opening..."
                                      : "Open Door"}
                                  </button>
                                )} */}
                                <Link
                                  onClick={() => {
                                    HandleOpenLocker(item._id, item.relay);
                                  }}
                                  disabled={itemLoadingStates[item._id]}
                                >
                                  <>
                                    {itemLoadingStates[item.locker_id] ? (
                                      <div
                                        className="spinner-grow text-primary"
                                        role="status"
                                      >
                                        <span className="visually-hidden">
                                          Loading...
                                        </span>
                                      </div>
                                    ) : (
                                      // <img src={LockerIcon} alt="open locker" />
                                      <Tooltip title="Open Locker">
                                        <img
                                          src={LockerIcon}
                                          alt="open locker"
                                        />
                                      </Tooltip>
                                    )}
                                  </>
                                </Link>

                                <Link to={`/locker/detail/${item._id}`}>
                                  <Tooltip title="Detail">
                                    <img src={InfoIcon} alt="detail" />
                                  </Tooltip>
                                </Link>

                                <Link to={`/locker/edit/${item._id}`}>
                                  <Tooltip title="Edit">
                                    <img src={EditIcon} alt="edit" />
                                  </Tooltip>
                                </Link>
                                {isSuperAdmin && (
                                  <Link onClick={() => handleDelete(item._id)}>
                                    <Tooltip title="Delete">
                                      <img src={DeleteIcon} alt="delete" />
                                    </Tooltip>
                                  </Link>
                                )}
                              </td>
                            </motion.tr>
                          ))}
                        {isNotFound && (
                          <tr>
                            <td colSpan={columnCount} className="text-center">
                              No Data Found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="table-num">
                    {data.length > 0 && (
                      <ReactPaginate
                        previousLabel={"<"}
                        nextLabel={">"}
                        breakLabel={"..."}
                        pageCount={totalPages}
                        forcePage={currentPage - 1} // react-paginate uses zero-based indexing
                        onPageChange={handlePageChange}
                        containerClassName={" dig-num"}
                        pageClassName={"dig-num"}
                        previousClassName={"num-btns"}
                        nextClassName={"num-btns"}
                        disabledClassName={"pagination-disabled"}
                        activeClassName={"pagination-active"}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        )}
      </div>
      <Modal
        title={
          zoomLocker
            ? `Locker ${lockerLabel(zoomLocker)}`
            : "QR code"
        }
        open={!!zoomLocker}
        onCancel={() => setZoomLocker(null)}
        footer={null}
        centered
      >
        {zoomLocker && qrImages[zoomLocker._id] ? (
          <div className={styles.qrLarge}>
            <img
              src={qrImages[zoomLocker._id]}
              alt={`QR code for locker ${lockerLabel(zoomLocker)}`}
            />
            {String(zoomLocker.department_name || "").trim() ? (
              <div className={styles.qrDeptLarge}>
                {zoomLocker.department_name}
              </div>
            ) : null}
          </div>
        ) : null}
      </Modal>
      <Modal
        title="Print on Avery labels"
        open={printOpen}
        onCancel={() => setPrintOpen(false)}
        okText={printing ? "Printing..." : "Print"}
        onOk={handlePrint}
        confirmLoading={printing}
        okButtonProps={{ disabled: printing }}
      >
        <p>
          Avery 5160 sheet (30 stickers). Click the position where the first QR
          should print. Stickers before that stay blank.
        </p>
        <p>
          {printLockers.length} label{printLockers.length === 1 ? "" : "s"},
          starting at position {startPosition}.
          {startPosition - 1 + printLockers.length > AVERY_PER_SHEET
            ? " Extra labels continue on the next sheet."
            : ""}
        </p>
        <div className={styles.sheetPreview}>
          {Array.from({ length: AVERY_PER_SHEET }, (_, index) => {
            const position = index + 1;
            const used =
              position >= startPosition && position <= filledThrough;
            const className = [
              styles.sheetCell,
              position === startPosition ? styles.sheetCellStart : "",
              used && position !== startPosition ? styles.sheetCellUsed : "",
            ]
              .filter(Boolean)
              .join(" ");
            return (
              <button
                key={position}
                type="button"
                className={className}
                onClick={() => setStartPosition(position)}
              >
                {position}
              </button>
            );
          })}
        </div>
        <p className={styles.printHint}>
          In the print dialog choose Actual size (100%). Do not use Fit to page.
        </p>
      </Modal>
    </div>
  );
};

export default Lockers;
